// @flow
import React, { Component } from 'react';
import { SummaryColumnDiv } from '../../../modules/CrudTable/components/TableComponentStyles';
import { Desktop } from '../../../components/Responsive';
import RequiresAction from './RequiresAction';

type Props = {
  currencyName: string,
  currencyType: string,
  requiresCryptoWallet: boolean,
  requiresBankAccount: boolean
};

export default class RequiresActionDesktop extends Component<Props> {
  render() {
    return (
      <SummaryColumnDiv>
        <Desktop>
          <RequiresAction
            currencyName={this.props.currencyName}
            currencyType={this.props.currencyType}
            requiresCryptoWallet={this.props.requiresCryptoWallet}
            requiresBankAccount={this.props.requiresBankAccount}
          />
        </Desktop>
      </SummaryColumnDiv>
    );
  }
}
